module.exports = __webpack_public_path__ + "img/tokelau.47342589.svg";